(function () {
    'use strict';

    function documentUploadConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/documentUploadConfiguration.html',
            link: function (scope) {

            }
        };
    }

    documentUploadConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('documentUploadConfiguration', documentUploadConfiguration);
})();
